import Dummy from "components/Dummy";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MobileStoreSettlementBest from "routes/vendor/settlementComp/MobileStoreSettlementBest";
import StoreSettlementAmount from "routes/vendor/settlementComp/StoreSettlementAmount";
import StoreSettlementStatus from "routes/vendor/settlementComp/StoreSettlementStatus";
import { commonBgColor } from "../constraint/constraints";

function MobileVendotStoreDetail() {
    const location = useLocation();
    const [store, setStore] = useState();

    useEffect(() => {
        if (location.state) {
            
            setStore(location.state.data);

        }
    }, [location])
    return (
        <Container backgroundColor={commonBgColor}>
            <div style={{height: "10vh"}}></div>
            <Container maxWidth={1200}>
                <VerticalFlex gap={30} backgroundColor={commonBgColor}>
                    <FlexChild height={"initial"} width={"90%"}>
                        <Center width={"100%"} textAlign={"left"}>
                            <P weight={"bold"} size={"min(4.2vw, 40px)"}>{store && store.storeName}</P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={"90%"}>
                        <StoreSettlementAmount storeId={store && store.id} />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                        <MobileStoreSettlementBest storeId={store && store.id} storeName={store && store.storeName} />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                        <StoreSettlementStatus storeId={store && store.id} />
                    </FlexChild>
                </VerticalFlex>
                <Dummy height={"50px"} />
            </Container>

        </Container>
    );
}

export default MobileVendotStoreDetail;